<template>
  <div>
    <Head title="Commands" />
    <h1 class="mb-8 text-3xl font-bold">Commands</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <Link class="btn-indigo" :href="`/commands/${bot}/create`">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Command</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">&nbsp;</th>
            <th class="pb-4 pt-6 px-6">Command</th>
            <th class="pb-4 pt-6 px-6">URL</th>
            <th class="pb-4 pt-6 px-6" colspan="2">Note</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(command, index) in commands.data" :key="command.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <label class="flex items-center select-none" :for="`active${command.id}`">
                <input :id="`active${command.id}`" @change="update(index)" v-model="command.active" class="ml-2 mr-1" type="checkbox" />
              </label>
              <icon v-if="command.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/commands/${bot}/${command.id}/edit`">
                {{ command.command }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/commands/${bot}/${command.id}/edit`" tabindex="-1">
                {{ command.api_url }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/commands/${bot}/${command.id}/edit`" tabindex="-1">
                {{ command.note }}
              </Link>
            </td>
            <td class="w-px border-t">
              <Link class="flex items-center px-4" :href="`/commands/${bot}/${command.id}/edit`" tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="commands.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="5">No commands found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="commands.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    commands: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
      bot: window.location.pathname.split("/").slice(-1)[0],
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(`/commands/${this.bot}`, pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    update(index) {
      let command = this.$inertia.form({
        bot_id: this.bot,
        command: this.commands.data[index].command,
        api_url: this.commands.data[index].api_url,
        note: this.commands.data[index].note,
        active: this.commands.data[index].active,
      });

      command.put(`/commands/${this.bot}/${this.commands.data[index].id}`)
    },
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
